// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookiePopover_wrapper__yqwm-","closeButton":"CookiePopover_closeButton__2oCGT"};